// src/screens/auth/LoginScreen.js
// 49차: AppHeader 제거 → 다른 탭과 동일한 직접 헤더 방식
//       TermsModal → 신규 소셜 연동(첫 가입)일 때만 표시
//       이용약관 WebView viewport 개선
// 50차: AppHeader 컴포넌트 적용
//       신규 Google 가입 시 약관 동의 이력 Firestore 저장
// 51차: 색 theme.js 단일화 — COLORS 참조 / 골드버튼 텍스트 ON_GOLD, 에러박스 빨강 통일
//       소셜 브랜드색(카카오/네이버/구글)·#0d0d1a 입력배경 보존
// 54차: Apple 로그인 연동 (iOS 전용, App Store 4.8 필수)
// 63차: 이메일 저장(AsyncStorage) + 비밀번호 저장 팝업 제거(autoComplete="off")
// 73차: 이용약관/개인정보처리방침 WebView 모달 — SafeAreaView가 Modal 안에서 top
// inset을 못 잡아 닫기 버튼이 상태바에 붙어보이던 문제 → useSafeAreaInsets()로 직접
// paddingTop 지정. 페이지 안 링크를 눌러 사이트 자체 홈으로 이탈하던 것도
// onShouldStartLoadWithRequest로 최초 URL 바깥 이동을 막음.
// 73차: SNS 로그인 버튼 순서 카카오>네이버>Google>Apple로 변경, 이모지/글자 아이콘
// (💬, "G", "N", 시스템폰트 앵글 문자) 대신 react-native-svg로 실제 브랜드 로고 모양을
// 그려 가독성 개선.
// 74차: 이용약관/개인정보처리방침 — 외부 WebView(PRIVACY_URL) 대신 앱 안 화면(LegalScreen)
// 으로 이동하도록 전환. 기존엔 두 항목이 같은 URL 하나만 가리켜 "이용약관 보기"를 눌러도
// 개인정보처리방침이 뜨는 문제와, 페이지 안 링크를 누르면 새 화면이 열리듯 이탈하는
// 문제가 있었음 — WebViewModal/PRIVACY_URL 전부 제거.
// 74차: SNS 로그인/회원가입 온보딩 재설계 — 기존엔 신규/기존 유저 구분 없이 SNS 버튼을
// 누르면 무조건 약관 동의 모달부터 띄웠음(타 앱들은 보통 먼저 인증하고 신규일 때만
// 추가 온보딩을 보여줌). 이제 버튼을 누르면 바로 각 provider 인증을 진행하고, 인증 성공
// 후 Firestore에 users 문서가 있는지로 신규/기존을 판별한다 — 기존 유저는 그대로
// 로그인 완료, 신규 유저는 SocialOnboardingScreen(신규 파일)으로 이동해 닉네임 입력 +
// 약관 동의를 마쳐야 계정이 실제로 생성된다(ensureSocialUserDoc이 거기서 호출됨).
// AppStack의 자동 Main 이동은 AuthContext의 authRedirectSuppressed로 그 사이에 보류.
// TermsModal은 이 흐름에서 더는 쓰이지 않아 제거 — 동일 UI를 SocialOnboardingScreen이 이어받음.
// 76차: 매장관리자 ID+PW 로그인 지원 — 입력창 라벨/placeholder만 "이메일 또는 아이디"로
// 변경(실제 분기 로직은 authService.js의 loginWithEmail()에서 처리, 이 화면은 변경 없음).
// 77차: "Expo Go에서 SNS 로그인이 전부 에러난다" 문의 — 원인은 이 화면 코드가 아니라 실행
// 환경 제약. 카카오/네이버는 socialAuthService.js에 이미 적혀있듯 네이티브 모듈(prebuild+EAS
// 빌드 필요)이라 Expo Go에서 원천적으로 동작 불가. Apple 로그인은 앱 고유 번들 ID에 등록된
// "Sign in with Apple" 네이티브 entitlement가 필요한데 Expo Go는 자체 번들 ID를 쓰므로 이
// 앱의 entitlement가 없어 실패. Google은 expo-auth-session이 예전엔 auth.expo.io 프록시로
// Expo Go에서도 됐지만 그 프록시가 폐지되어 SDK 54 기준 Expo Go에서는 redirect URI를
// 안정적으로 못 받아 실패 가능성이 높음 — 넷 다 코드 버그가 아니라 "Expo Go 자체의 한계".
// 실기기 EAS 개발 빌드(dev client)에서는 정상 동작해야 함. 매번 원인 모를 네이티브 에러를
// 던지는 대신, Expo Go로 실행 중임을 감지해 미리 안내하도록 아래 SNS 핸들러에 가드 추가.
// 78차 28차: Maestro E2E 로그인 플로우로 안드로이드 에뮬레이터에서 처음 실행해보다 발견한
// 실제 버그 — Google.useAuthRequest()가 androidClientId 없이 호출되면 안드로이드에서
// "Client Id property androidClientId must be defined..."로 이 화면 진입 즉시(Google
// 버튼을 누르지 않아도) 렌더링이 죽고 있었음. 지금까지 iOS 빌드로만 테스트해서 안 걸림.
// .env에 EXPO_PUBLIC_GOOGLE_ANDROID_CLIENT_ID가 아예 없어 webClientId로 폴백해 크래시만
// 막음 — 실제 Google 로그인은 진짜 안드로이드용 OAuth 클라이언트 ID 발급 전까지 여전히
// 안 되므로, handleGoogleLogin에 안드로이드+미설정 시 안내 Alert 추가.

import React, { useState, useEffect, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, TextInput, TouchableOpacity,
  StyleSheet, KeyboardAvoidingView, Platform,
  ScrollView,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Svg, { Path } from 'react-native-svg';
import Constants from 'expo-constants';
import * as Google from 'expo-auth-session/providers/google';
import * as WebBrowser from 'expo-web-browser';
import * as AppleAuthentication from 'expo-apple-authentication';
import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithCredential,
} from 'firebase/auth';
import { loginWithEmail, getUserProfile } from '../../services/authService';
import { signInWithKakao, signInWithNaver, signInWithGoogleNative, initNaver, signInWithKakaoWeb, signInWithNaverWeb } from '../../services/socialAuthService';
import { auth } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { TextButton } from '../../components/common/Buttons';
import { CheckmarkIcon, WarningIcon, IconLabel } from '../../components/common/Icons';
import { COLORS } from '../../constants/theme';

WebBrowser.maybeCompleteAuthSession();

// 77차: Expo Go 실행 여부 감지 — 카카오/네이버/Apple/Google SNS 로그인 전부 Expo Go에서
// 동작하지 않는 이유가 있어(위 헤더 주석 참고), 시도 전에 미리 안내하기 위함.
const isExpoGo = Constants.appOwnership === 'expo';
const EXPO_GO_SNS_NOTICE =
  'Expo Go에서는 SNS 로그인을 테스트할 수 없어요.\n' +
  '네이티브 기능(카카오·네이버 SDK, Apple 인증서, Google 리다이렉트)이 필요해서, ' +
  'EAS 개발 빌드(dev client)나 실제 앱 빌드에서 확인해주세요.';
// 78차 39차: 웹 버전(매장관리자 URL 접속용) 대응 — 카카오/네이버 SDK, Apple 인증서는
// 웹에 대응 네이티브 모듈이 없어 브라우저에서 누르면 그대로 에러가 남. 매장관리자는
// 어차피 ID/PW 로그인만 쓰므로 이 화면 자체는 웹에서도 문제없이 동작 — SNS 버튼만
// Expo Go와 동일한 안내로 막음(isExpoGo 재사용 조건에 웹도 추가).
const isWeb = Platform.OS === 'web';
const SNS_UNSUPPORTED_NOTICE = isWeb
  ? '웹 버전에서는 SNS 로그인을 지원하지 않아요.\nID/PW 로그인 또는 앱에서 이용해주세요.'
  : EXPO_GO_SNS_NOTICE;

// 73차: SNS 버튼 브랜드 로고 (react-native-svg)
function AppleGlyph() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24" fill="#ffffff">
      <Path d="M16.365 1.43c0 1.14-.462 2.15-1.217 2.912-.845.86-2.13 1.51-3.166 1.44-.13-1.11.44-2.27 1.176-3.02.83-.85 2.27-1.48 3.207-1.332zM20.99 17.06c-.5 1.15-.74 1.66-1.38 2.68-.9 1.42-2.16 3.19-3.73 3.2-1.4.02-1.76-.9-3.66-.89-1.9.01-2.3.9-3.7.88-1.57-.02-2.76-1.62-3.66-3.04-2.51-3.93-2.77-8.54-1.22-11 1.1-1.75 2.83-2.77 4.45-2.77 1.65 0 2.69.9 4.06.9 1.32 0 2.13-.9 4.05-.9 1.44 0 2.97.78 4.06 2.13-3.57 1.95-2.99 6.98.7 8.79z" />
    </Svg>
  );
}
function GoogleGlyph() {
  return (
    <Svg width={18} height={18} viewBox="0 0 18 18">
      <Path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" />
      <Path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" />
      <Path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z" />
      <Path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" />
    </Svg>
  );
}
function KakaoGlyph() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24" fill="#3C1E1E">
      <Path d="M12 3C6.477 3 2 6.463 2 10.749c0 2.735 1.828 5.138 4.573 6.502-.2.75-.727 2.72-.833 3.142-.13.522.19.516.4.375.166-.111 2.638-1.792 3.71-2.524.698.103 1.42.157 2.15.157 5.523 0 10-3.462 10-7.652C22 6.463 17.523 3 12 3z" />
    </Svg>
  );
}
function NaverGlyph() {
  return (
    <Svg width={16} height={16} viewBox="0 0 24 24" fill="#ffffff">
      <Path d="M16.273 12.845L7.376 0H0v24h7.727V11.156L16.624 24H24V0h-7.727z" />
    </Svg>
  );
}

const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const SURFACE    = COLORS.surface;
const BORDER     = 'rgba(212,168,67,0.2)';
const TEXT       = COLORS.text;
const TEXT_MUTED = 'rgba(255,255,255,0.35)';
const TEXT_SEC   = COLORS.textSec;
const RED        = COLORS.red;
const ON_GOLD    = COLORS.onGold;
const GREEN      = COLORS.green;

// 63차: 이메일 저장 키
const SAVED_EMAIL_KEY = '@unlock_saved_email';

export default function LoginScreen({ navigation }) {
  const { isLoggedIn, authRedirectSuppressed, adminRole, setAuthRedirectSuppressed } = useAuth();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const passwordRef = useRef(null); // 78차 43차: 웹에서 Enter로 로그인 제출 — 아이디 입력 후 Enter로 비밀번호칸 포커스 이동용
  const [errorMsg, setErrorMsg] = useState('');
  const [appleAvailable, setAppleAvailable] = useState(false);

  // 63차: 이메일 저장 상태
  const [saveEmail,  setSaveEmail]  = useState(false);

  // 63차: 앱 시작 시 저장된 이메일 불러오기
  useEffect(() => {
    AsyncStorage.getItem(SAVED_EMAIL_KEY).then(saved => {
      if (saved) { setEmail(saved); setSaveEmail(true); }
    }).catch(() => {});
  }, []);

  // 78차 56차: 이 goBack() 이펙트를 한 번 제거했다가(AppStack의 reset()과 경쟁한다고
  // 오판) 다시 복원함 — 실기기 반복 검증 결과, presentation 방식(fullScreenModal/card)과
  // 무관하게 AppStack이 **외부 navRef로** 호출하는 goBack()/reset()/navigate()는 전부
  // JS 라우트 상태만 바꿀 뿐 네이티브 화면 전환을 실제로 못 걷어내고(하드웨어 뒤로가기
  // 로만 걷힘), 오직 화면 자신의 `navigation` prop으로 직접 호출해야만 신뢰성 있게
  // 동작하는 것으로 최종 확인됨 — 이 화면이 자기 자신을 닫는 것이 유일하게 검증된
  // 방식이라 되살림(RegisterScreen에도 동일 패턴 신규 추가, AppStack의 중앙집중
  // navigate/reset 로직은 제거).
  useEffect(() => {
    if (isLoggedIn && !authRedirectSuppressed) {
      navigation.goBack();
      if (adminRole === 'store' || adminRole === 'super') {
        navigation.navigate('Main');
      } else {
        navigation.navigate('Main', { screen: 'Home' });
      }
    }
  }, [isLoggedIn, authRedirectSuppressed, adminRole]);

  useEffect(() => {
    let mounted = true;
    if (Platform.OS === 'ios') {
      AppleAuthentication.isAvailableAsync()
        .then((available) => { if (mounted) setAppleAvailable(available); })
        .catch(() => { if (mounted) setAppleAvailable(false); });
    }
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    try { initNaver(); } catch (_) {}
  }, []);

  // 78차 27차: Maestro E2E로 안드로이드 실기기 경로를 처음 확인하다가 발견한 실제 버그 —
  // expo-auth-session의 Google.useAuthRequest()는 Android에서 androidClientId가 없으면
  // "Client Id property `androidClientId` must be defined..."로 렌더링 자체가 즉시 죽는다
  // (Rules of Hooks상 조건부 호출 불가 — 안 부르는 방식으로는 회피 불가). 지금까지 iOS
  // 빌드로만 테스트해와서 안 걸렸을 뿐, 이 화면은 안드로이드에서 항상(로그인 화면
  // 진입만 해도, Google 버튼을 누르지 않아도) 크래시하고 있었음. .env에
  // EXPO_PUBLIC_GOOGLE_ANDROID_CLIENT_ID 자체가 없어 webClientId로 폴백해 크래시만
  // 막고, 실제 Google 로그인 시도는 아래 handleGoogleLogin의 안내로 대체(진짜
  // 안드로이드 OAuth 클라이언트 ID 발급 전까지는 webClientId로 시도해도 Google 서버가
  // 거부함 — 알 수 없는 에러 대신 명확한 안내가 낫다고 판단).
  const androidClientId = process.env.EXPO_PUBLIC_GOOGLE_ANDROID_CLIENT_ID;
  // 80차 계속: 웹은 카카오/네이버와 동일하게 이 페이지 자신의 주소를 redirectUri로 명시 —
  // Google Cloud Console의 Web OAuth 클라이언트에 이미 등록된 카카오/네이버와 같은 두
  // 도메인(https://unlockapp.co.kr/, https://roomescape-80d4d.web.app/)을 그대로 재사용.
  const googleRedirectUri = isWeb ? `${window.location.origin}${window.location.pathname}` : undefined;
  // 80차 계속: [버그 수정] 웹에서 "구글 토큰을 받지 못했습니다" 에러 — Google.useAuthRequest()는
  // 웹에서 responseType 미지정 시 기본값이 ResponseType.Token(access_token만)이라 id_token이
  // 아예 안 옴. useIdTokenAuthRequest()는 웹에서만 responseType을 IdToken으로 강제하고
  // iOS는 기존 Code 교환 흐름을 그대로 유지해(node_modules/expo-auth-session 소스로 확인)
  // iOS 회귀 없이 웹만 고칠 수 있는, 라이브러리가 정확히 이 용도로 제공하는 함수.
  const [request, response, promptAsync] = Google.useIdTokenAuthRequest({
    webClientId: process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID,
    iosClientId: process.env.EXPO_PUBLIC_GOOGLE_IOS_CLIENT_ID,
    androidClientId: androidClientId || process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID,
    scopes: ['profile', 'email'],
    ...(googleRedirectUri ? { redirectUri: googleRedirectUri } : {}),
  });

  // 74차: SNS 인증 성공 후 공통 처리 — Firestore에 users 문서가 있으면 기존 유저라
  // 그대로 두고(AppStack이 알아서 Main으로 이동), 없으면 신규 유저이므로 계정을 아직
  // 만들지 않은 채 SocialOnboarding 화면으로 보내 닉네임/약관 동의를 받는다. 그 사이
  // AppStack의 "로그인되면 Main으로" 자동 이동은 authRedirectSuppressed로 보류.
  // getUserProfile이 실패해도(네트워크 등) 신규로 취급해 온보딩으로 보낸다 — 온보딩에서
  // 호출하는 ensureSocialUserDoc은 문서가 이미 있으면 아무 것도 안 하는 멱등 함수라
  // 기존 유저가 실수로 여기 왔더라도 데이터를 덮어쓰지 않는다.
  // 80차 후속: [버그 수정, 중간 심각도 — fork로 발견] 카카오/네이버는 provider ID로
  // 결정론적 uid(kakao:{id})를 써서, 탈퇴(deleteAccountCF)로 Auth 계정만 삭제되고
  // Firestore users 문서는 익명화(soft-delete)만 되는데, 같은 SNS 계정으로 재로그인하면
  // 정확히 같은 uid의 문서가 "존재하기만 하면" 무조건 기존 유저로 취급해 온보딩 없이
  // 그대로 로그인시키고 있었음 — 탈퇴한 유령 프로필(닉네임 "탈퇴한 회원" 등)이 그대로
  // 부활하는 구조. isDeleted:true인 문서는 기존 유저가 아니라 새로 온보딩할 대상으로
  // 취급(구글/애플은 Firebase가 uid 매핑을 관리해 삭제 시 새 uid가 발급되므로 해당 없음).
  const handleSocialAuthResult = async (social) => {
    setAuthRedirectSuppressed(true);
    let existing = null;
    try { existing = await getUserProfile(social.uid); } catch (_) {}
    if (existing && existing.isDeleted !== true) {
      setAuthRedirectSuppressed(false);
      return;
    }
    navigation.navigate('SocialOnboarding', { social });
  };

  useEffect(() => {
    if (response?.type === 'success') {
      const { id_token } = response.params;
      if (!id_token) { setErrorMsg('구글 토큰을 받지 못했습니다.'); return; }
      setLoading(true);
      const credential = GoogleAuthProvider.credential(id_token);
      signInWithCredential(auth, credential)
        .then(({ user }) => handleSocialAuthResult({
          uid: user.uid, email: user.email || '',
          displayName: user.displayName || '', photoURL: user.photoURL || '',
          provider: 'google',
        }))
        .catch(e => setErrorMsg('구글 로그인 실패: ' + e.message))
        .finally(() => setLoading(false));
    } else if (response?.type === 'error') {
      setErrorMsg('구글 로그인 오류가 발생했습니다.');
    }
  }, [response]);

  // 63차: 이메일 로그인 + 이메일 저장
  const handleEmailLogin = async () => {
    if (!email.trim() || !password) { setErrorMsg('이메일과 비밀번호를 입력해주세요.'); return; }
    setErrorMsg('');
    try {
      setLoading(true);
      await loginWithEmail({ email: email.trim(), password });
      // 63차: 로그인 성공 후 이메일 저장 처리
      if (saveEmail) {
        await AsyncStorage.setItem(SAVED_EMAIL_KEY, email.trim()).catch(() => {});
      } else {
        await AsyncStorage.removeItem(SAVED_EMAIL_KEY).catch(() => {});
      }
    } catch (e) {
      const msgs = {
        'auth/user-not-found':        '등록되지 않은 이메일입니다.',
        'auth/wrong-password':        '비밀번호가 올바르지 않습니다.',
        'auth/invalid-credential':    '이메일 또는 비밀번호가 올바르지 않습니다.',
        'auth/invalid-email':         '올바르지 않은 이메일 형식입니다.',
        'auth/too-many-requests':     '로그인 시도가 너무 많습니다. 잠시 후 다시 시도해주세요.',
        'auth/network-request-failed':'네트워크 연결을 확인해주세요.',
      };
      setErrorMsg(msgs[e.code] || `로그인 실패 (${e.code})`);
    } finally { setLoading(false); }
  };

  // 80차 후속: expo-auth-session(브라우저 리다이렉트)이 Android 타입 OAuth 클라이언트와
  // 근본적으로 호환이 안 돼("Invalid" 에러, 계정 선택란도 안 뜸) Android만 네이티브 SDK
  // (signInWithGoogleNative, socialAuthService.js)로 전환 — iOS는 기존 flow 그대로 유지
  // (정상 동작 중이라 안 건드림). Kakao/Naver와 동일한 try/catch/loading 패턴.
  const handleGoogleLogin = async () => {
    if (isExpoGo && !isWeb) { showAlert('Expo Go 제한', EXPO_GO_SNS_NOTICE); return; }
    if (Platform.OS === 'android') {
      setErrorMsg('');
      try {
        setLoading(true);
        const social = await signInWithGoogleNative();
        await handleSocialAuthResult(social);
      } catch (e) {
        if (e?.code !== 'GOOGLE_CANCELLED') {
          setErrorMsg('구글 로그인 실패: ' + (e?.message || '알 수 없는 오류'));
        }
      } finally { setLoading(false); }
      return;
    }
    setErrorMsg('');
    promptAsync();
  };

  const handleAppleLogin = async () => {
    if (isExpoGo || isWeb) { showAlert(isWeb ? '지원 안 함' : 'Expo Go 제한', SNS_UNSUPPORTED_NOTICE); return; }
    setErrorMsg('');
    try {
      setLoading(true);
      const appleCredential = await AppleAuthentication.signInAsync({
        requestedScopes: [
          AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
          AppleAuthentication.AppleAuthenticationScope.EMAIL,
        ],
      });
      const { identityToken, fullName, email: appleEmail } = appleCredential;
      if (!identityToken) { setErrorMsg('애플 토큰을 받지 못했습니다.'); setLoading(false); return; }
      const provider = new OAuthProvider('apple.com');
      const credential = provider.credential({ idToken: identityToken });
      const { user } = await signInWithCredential(auth, credential);
      const composedName = fullName
        ? [fullName.familyName, fullName.givenName].filter(Boolean).join('')
        : '';
      await handleSocialAuthResult({
        uid: user.uid, email: appleEmail || user.email || '',
        displayName: composedName || user.displayName || '', photoURL: '',
        provider: 'apple',
      });
    } catch (e) {
      if (e?.code !== 'ERR_REQUEST_CANCELED') {
        setErrorMsg('애플 로그인 실패: ' + (e?.message || '알 수 없는 오류'));
      }
    } finally { setLoading(false); }
  };

  // 80차 계속: 카카오/네이버는 웹에서도 열기로 함(unlockapp.co.kr을 일반 고객용 데모로
  // 홍보하게 되면서 우선순위가 가장 높다고 판단) — Expo Go 제한은 네이티브에만 해당되므로
  // isWeb일 땐 그 가드를 건너뛰고 signInWithKakaoWeb/signInWithNaverWeb으로 분기.
  const handleKakaoLogin = async () => {
    if (isExpoGo && !isWeb) { showAlert('Expo Go 제한', EXPO_GO_SNS_NOTICE); return; }
    setErrorMsg('');
    try {
      setLoading(true);
      const social = isWeb ? await signInWithKakaoWeb() : await signInWithKakao();
      await handleSocialAuthResult(social);
    } catch (e) {
      if (!(e?.code === 'E_CANCELLED_OPERATION' || e?.code === 'KAKAO_CANCELLED' || /cancel/i.test(e?.message || ''))) {
        setErrorMsg('카카오 로그인 실패: ' + (e?.message || '알 수 없는 오류'));
      }
    } finally { setLoading(false); }
  };

  const handleNaverLogin = async () => {
    if (isExpoGo && !isWeb) { showAlert('Expo Go 제한', EXPO_GO_SNS_NOTICE); return; }
    setErrorMsg('');
    try {
      setLoading(true);
      const social = isWeb ? await signInWithNaverWeb() : await signInWithNaver();
      await handleSocialAuthResult(social);
    } catch (e) {
      if (e?.code !== 'NAVER_CANCELLED') {
        setErrorMsg('네이버 로그인 실패: ' + (e?.message || '알 수 없는 오류'));
      }
    } finally { setLoading(false); }
  };

  return (
    <SafeAreaView style={s.safeArea} edges={['bottom']}>
      <AppHeader />

      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={{ flex: 1 }}
        keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : 0}
      >
        <ScrollView
          contentContainerStyle={s.inner}
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
          bounces={false}
        >
          <View style={s.card}>
            <Text style={s.title}>로그인</Text>

            {errorMsg ? (
              <View style={s.errorBox}><IconLabel Icon={WarningIcon} size={s.errorText.fontSize || 13} color={s.errorText.color} textStyle={s.errorText}>{errorMsg}</IconLabel></View>
            ) : null}

            <Text style={s.label}>이메일 또는 아이디</Text>
            <TextInput style={s.input}
              placeholder="이메일 또는 아이디를 입력해주세요" placeholderTextColor={TEXT_MUTED}
              value={email} onChangeText={v => { setEmail(v); setErrorMsg(''); }}
              autoCapitalize="none" autoCorrect={false}
              // 63차: 비밀번호 저장 팝업 방지
              autoComplete="off"
              textContentType="username"
              returnKeyType="next"
              onSubmitEditing={() => passwordRef.current?.focus()}
              blurOnSubmit={false}
            />

            <Text style={s.label}>비밀번호</Text>
            <TextInput style={s.input}
              ref={passwordRef}
              placeholder="비밀번호를 입력해주세요" placeholderTextColor={TEXT_MUTED}
              value={password} onChangeText={v => { setPassword(v); setErrorMsg(''); }}
              secureTextEntry
              // 63차: 비밀번호 저장 팝업 방지
              autoComplete="off"
              textContentType="oneTimeCode"
              returnKeyType="done"
              onSubmitEditing={handleEmailLogin}
            />

            {/* 63차: 이메일 저장 체크박스 + 비밀번호 찾기 */}
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, marginTop: -6 }}>
              <TouchableOpacity
                style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}
                onPress={() => setSaveEmail(v => !v)}
                activeOpacity={0.7}>
                <View style={[s.checkbox, saveEmail && s.checkboxOn]}>
                  {saveEmail && <CheckmarkIcon size={s.checkmark.fontSize || 12} color={s.checkmark.color} />}
                </View>
                <Text style={{ color: TEXT_MUTED, fontSize: 13 }}>이메일 저장</Text>
              </TouchableOpacity>
              <TextButton
                label="비밀번호를 잊으셨나요?"
                onPress={() => navigation.replace('ForgotPassword')}
                textStyle={s.forgotText}
              />
            </View>

            <GradientButton
              label={loading ? '로그인 중...' : '로그인'}
              onPress={handleEmailLogin}
              disabled={loading}
              style={s.loginBtn}
              textStyle={s.loginBtnText}
            />

            <View style={s.dividerRow}>
              <View style={s.dividerLine} />
              <Text style={s.dividerText}>또는 SNS로 계속하기</Text>
              <View style={s.dividerLine} />
            </View>

            {/* 80차 후속: [App Store 4.8 위험요소 선제조치] Apple 로그인이 목록 맨 끝(4번째)
                에 있어서, 이 화면이 ScrollView인 것과 합쳐지면 심사관이 스크롤을 안 하면
                아예 안 보일 수 있었음 — Apple 공식 HIG가 "Sign in with Apple 버튼을 보려고
                스크롤이 필요하면 안 된다"고 명시(다른 SNS 버튼과 동일한 크기/스타일은
                이미 만족하고 있었음, 순서만 문제). 다른 SNS 로그인을 제공하면 Apple 로그인도
                동등하게 노출해야 하는 4.8 가이드라인 대응 — 안드로이드는 이 버튼 자체가 안
                뜨니(appleAvailable) 영향 없음. */}
            {appleAvailable && (
              <TouchableOpacity style={[s.socialBtn, s.appleBtn]}
                onPress={handleAppleLogin} disabled={loading}>
                <AppleGlyph />
                <Text style={[s.socialBtnText, { color: '#ffffff' }]}>Apple로 계속하기</Text>
              </TouchableOpacity>
            )}

            <TouchableOpacity style={[s.socialBtn, s.kakaoBtn]}
              onPress={handleKakaoLogin} disabled={loading}>
              <KakaoGlyph />
              <Text style={[s.socialBtnText, { color: '#3C1E1E' }]}>카카오톡으로 계속하기</Text>
            </TouchableOpacity>

            <TouchableOpacity style={[s.socialBtn, s.naverBtn]}
              onPress={handleNaverLogin} disabled={loading}>
              <NaverGlyph />
              <Text style={[s.socialBtnText, { color: '#ffffff' }]}>네이버로 계속하기</Text>
            </TouchableOpacity>

            {/* 80차 후속: disabled 조건이 Android에서도 여전히 옛 expo-auth-session의
                request(iOS 전용 경로에서만 쓰임)에 묶여 있었음 — Android는 네이티브
                signInWithGoogleNative()로 전환됐으니 request와 무관하게 loading만 봐야 함. */}
            <TouchableOpacity style={s.socialBtn}
              onPress={handleGoogleLogin} disabled={Platform.OS === 'android' ? loading : (!request || loading)}>
              <GoogleGlyph />
              <Text style={s.socialBtnText}>Google로 계속하기</Text>
            </TouchableOpacity>

            <View style={s.registerRow}>
              <Text style={s.registerText}>계정이 없으신가요? </Text>
              {/* 78차 56차: navigate → replace — Main→Login→Register처럼 인증 모달이
                  2겹 쌓이면 회원가입 완료 후 AppStack의 reset()이 Main까지 못 가고
                  Login에서 멈추는 버그가 있었음(실기기 테스트로 발견) — 이 화면들끼리는
                  항상 최대 한 겹만 쌓이도록 replace로 통일 */}
              <TextButton label="회원가입" onPress={() => navigation.replace('Register')} textStyle={s.registerLink} />
            </View>

            <TextButton label="비회원으로 계속하기" onPress={() => navigation.goBack()} style={s.guestBtn} textStyle={s.guestBtnText} />

            <View style={s.termsRow}>
              <TextButton label="이용약관" onPress={() => navigation.navigate('Terms')} textStyle={s.termsText} />
              <Text style={s.termsDot}> · </Text>
              <TextButton label="개인정보처리방침" onPress={() => navigation.navigate('Privacy')} textStyle={s.termsText} />
            </View>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const s = StyleSheet.create({
  safeArea:    { flex: 1, backgroundColor: BG },
  inner:       { flexGrow: 1, paddingTop: 16, paddingBottom: 40 },
  card:        { marginHorizontal: 16, backgroundColor: SURFACE, borderRadius: 16, padding: 24, borderWidth: 1, borderColor: BORDER },
  title:       { fontSize: 24, fontWeight: '900', color: TEXT, textAlign: 'center', marginBottom: 20 },
  errorBox:    { backgroundColor: COLORS.redBg, borderRadius: 8, borderWidth: 1, borderColor: COLORS.redBorder, padding: 12, marginBottom: 16 },
  errorText:   { color: RED, fontSize: 13, lineHeight: 18 },
  label:       { color: TEXT, fontSize: 13, fontWeight: '600', marginBottom: 7 },
  input:       { backgroundColor: '#0d0d1a', borderRadius: 10, borderWidth: 1, borderColor: BORDER, paddingHorizontal: 14, height: 50, color: TEXT, fontSize: 14, marginBottom: 14 },
  // 63차: 이메일 저장 체크박스
  checkbox:    { width: 18, height: 18, borderRadius: 4, borderWidth: 1.5, borderColor: BORDER,
                 justifyContent: 'center', alignItems: 'center', backgroundColor: '#0d0d1a' },
  checkboxOn:  { backgroundColor: GOLD, borderColor: GOLD },
  checkmark:   { color: ON_GOLD, fontSize: 11, fontWeight: '900' },
  forgotText:  { color: TEXT_MUTED, fontSize: 13, textDecorationLine: 'underline' },
  loginBtn:    { marginBottom: 24 },
  loginBtnText:{ fontSize: 17 },
  dividerRow:  { flexDirection: 'row', alignItems: 'center', marginBottom: 16 },
  dividerLine: { flex: 1, height: 1, backgroundColor: BORDER },
  dividerText: { color: TEXT_MUTED, fontSize: 11, marginHorizontal: 10 },
  socialBtn:   { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRadius: 10, height: 50, marginBottom: 10, gap: 10 },
  appleBtn:    { backgroundColor: '#000000', borderWidth: 1, borderColor: 'rgba(255,255,255,0.2)' },
  kakaoBtn:    { backgroundColor: '#FEE500' },
  naverBtn:    { backgroundColor: '#03C75A' },
  socialBtnText:{ fontSize: 15, fontWeight: '700', color: '#1a1a1a' },
  registerRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 20, marginBottom: 14 },
  registerText:{ color: TEXT_MUTED, fontSize: 14 },
  registerLink:{ color: TEXT, fontSize: 14, fontWeight: '800' },
  termsRow:    { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  termsText:   { color: TEXT_MUTED, fontSize: 12, textDecorationLine: 'underline' },
  termsDot:    { color: TEXT_MUTED, fontSize: 12 },
  // 78차 20차: TextButton(Buttons.js) 자체가 alignSelf:'flex-start'를 갖고 있어서
  // (이용약관 등 다른 텍스트 옆에 나란히 두는 인라인 용도가 기본값) 이 버튼처럼 혼자
  // 한 줄 전체를 차지하며 가운데 놓여야 하는 경우엔 alignItems:'center'(부모 기준
  // 자식 정렬)만으론 소용없고 자기 자신의 alignSelf를 직접 덮어써야 함 — 그동안
  // 왼쪽으로 쏠려 보이던 원인.
  guestBtn:    { alignSelf: 'center', alignItems: 'center', paddingVertical: 14, marginTop: 6 },
  guestBtnText:{ color: TEXT_MUTED, fontSize: 14, textDecorationLine: 'underline' },
});